import { useMainSideNavStore } from '~/components/v2/store/features/workspace/useMainSideNavStore';

export type GetMainSideNavItemSelectedParams = {
  isRouteSelected: boolean;
  hasActiveOverlay: boolean;
};

export const getMainSideNavItemSelected = ({
  isRouteSelected,
  hasActiveOverlay,
}: GetMainSideNavItemSelectedParams): boolean => isRouteSelected && !hasActiveOverlay;

export type UseMainSideNavItemSelectedParams = {
  isRouteSelected: boolean;
};

export type UseMainSideNavItemSelectedResult = {
  isSelected: boolean;
};

export const useMainSideNavItemSelected = ({
  isRouteSelected,
}: UseMainSideNavItemSelectedParams): UseMainSideNavItemSelectedResult => {
  const hasActiveOverlay = useMainSideNavStore((state) => state.activeOverlay !== null);

  return { isSelected: getMainSideNavItemSelected({ hasActiveOverlay, isRouteSelected }) };
};
